import { Injectable } from '@angular/core'
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http'
import { Observable } from 'rxjs'

@Injectable()
export class TrimInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (!req.body) return next.handle(req)

    let newBody: any

    // Handle trim when request is FormData
    if (req.body instanceof FormData) {
      newBody = new FormData()
      req.body.forEach((value, key) => {
        if (typeof value === 'string') {
          newBody.append(key, value.trim())
        } else {
          newBody.append(key, value)
        }
      })
    }
    //Handle trim when request is objects
    else if (typeof req.body === 'object') {
      newBody = this.trimStrings(req.body)
    } else {
      newBody = req.body
    }

    const clonedReq = req.clone({ body: newBody })
    return next.handle(clonedReq)
  }

  private trimStrings(obj: any): any {
    if (Array.isArray(obj)) {
      return obj.map((item) => this.trimStrings(item))
    } else if (obj && typeof obj === 'object') {
      const trimmed: any = {}
      for (const key of Object.keys(obj)) {
        const value = obj[key]
        if (typeof value === 'string') {
          trimmed[key] = value.trim()
        } else {
          trimmed[key] = this.trimStrings(value)
        }
      }
      return trimmed
    }
    return obj
  }
}
